import request from '@/utils/request'
const BASE_URL = '/Attendance'

//考勤
export default {
    list(data) {
        return request({
            url: BASE_URL + '/List',
            method: 'post',
            data
        })
    },
    //获取班级学生
    getStudentsV2(data) {
        return request({
            url: BASE_URL + '/GetStudentsV2',
            method: 'get',
            params: {...data }
        })
    },
    getStudentsV3(data) {
        return request({
            url: BASE_URL + '/GetStudentsV3',
            method: 'get',
            params: {...data }
        })
    },
    //获取年级统计
    getStat1(data) {
        return request({
            url: BASE_URL + '/GetStat1',
            method: 'get',
            params: {
                attendanceDate: data.date,
                sectionId: data.sectionId,
            }
        })
    },
    //获取班级统计
    getStat2(data) {
        return request({
            url: BASE_URL + '/GetStat2',
            method: 'get',
            params: {
                attendanceDate: data.date,
                sectionId: data.sectionId,
                gradeId: data.gradeId
            }
        })
    },
    //获取年级统计v1
    getStat1V2(data) {
        return request({
            url: BASE_URL + '/GetStat1V2',
            method: 'get',
            params: {
                attendanceDate: data.date,
                sectionNumber: data.section,
            }
        })
    },
    //获取年级统计v2
    getStat2V2(data) {
        return request({
            url: BASE_URL + '/GetStat2V2',
            method: 'get',
            params: {
                attendanceDate: data.date,
                sectionNumber: data.section,
                gradeId: data.gradeId
            }
        })
    },
    getStudentStat(params) {
        return request({
            url: BASE_URL + '/GetStudentStat',
            method: 'get',
            params
        })
    },
    getIndexLeaveDts(params) {
        return request({
            url: BASE_URL + '/GetIndexLeaveDts',
            method: 'get',
            params
        })
    },
    getStudentAttendanceStat(params) {
        return request({
            url: BASE_URL + '/GetStudentAttendanceStat',
            method: 'get',
            params
        })
    },
    getTeacherAttendanceStat(params) {
        return request({
            url: BASE_URL + '/GetTeacherAttendanceStat',
            method: 'get',
            params
        })
    },
    getIndexStat(time = null) {
        return request({
            url: BASE_URL + '/GetIndexStat',
            method: 'get',
            params: {
                time
            }
        })
    },
    getLogList(params) {
        return request({
            url: BASE_URL + '/GetLogList',
            method: 'get',
            params
        })
    },
    getLogListV2(params) {
        return request({
            url: BASE_URL + '/GetLogListV2',
            method: 'get',
            params
        })
    },
    unReport(TimetableDtsId) {
        return request({
            url: BASE_URL + '/UnReport',
            method: 'post',
            data: { TimetableDtsId }
        })
    },
    report(TimetableDtsId) {
        return request({
            url: BASE_URL + '/Report',
            method: 'post',
            data: { TimetableDtsId }
        })
    },
    getNightStudents(data) {
        return request({
            url: BASE_URL + '/GetNightStudents',
            method: 'post',
            data
        })
    },
    nightRollCall(data) {
        return request({
            url: BASE_URL + '/NightRollCall',
            method: 'post',
            data
        })
    },
    getStayStudents(data) {
        return request({
            url: BASE_URL + '/GetStayStudents',
            method: 'post',
            data
        })
    },
    stayRollCall(data) {
        return request({
            url: BASE_URL + '/StayRollCall',
            method: 'post',
            data
        })
    },
    getNightAttendanceStat(data) {
        return request({
            url: BASE_URL + '/GetNightAttendanceStat',
            method: 'post',
            data
        })
    },
    getNightAttendanceStudentList(data) {
        return request({
            url: BASE_URL + '/GetNightAttendanceStudentList',
            method: 'post',
            data
        })
    },
    export (data) {
        return request({
            url: BASE_URL + '/Export',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
    exportStudentAttendanceStat(data) {
        return request({
            url: BASE_URL + '/ExportStudentAttendanceStat',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
    exportTeacherAttendanceStat(data) {
        return request({
            url: BASE_URL + '/ExportTeacherAttendanceStat',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
    exportStudentStat(data) {
        return request({
            url: BASE_URL + '/ExportStudentStat',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
    exportIndex(time = "", t) {
        var url = "?t=" + t;
        if (time) url += "&time=" + time;
        return request({
            url: BASE_URL + '/ExportIndexStat' + url,
            method: 'post',
            responseType: 'blob',
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
    exportNightStudents(data) {
        return request({
            url: BASE_URL + '/ExportNightStudents',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
    exportStayStudents(data) {
        return request({
            url: BASE_URL + '/ExportStayStudents',
            method: 'post',
            responseType: 'blob',
            data
        }).then(res => {
            var file = res.data;
            var disposition = res.headers['content-disposition'];
            // console.log('disposition', disposition);

            var fileName = "导出";
            if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
                var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
                fileName = decodeURI(text);
            }

            if (navigator.msSaveBlob) {
                // IE10+下载
                navigator.msSaveBlob(file, fileName);
            } else {
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.target = "_blank";
                elink.href = URL.createObjectURL(file);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
            return Promise.resolve();
        });
    },
}